export default "__VITE_ASSET__BgIsa6Vt__"